import 'babel-polyfill';
import * as Sentry from '@sentry/browser';
import throttle from 'lodash/throttle';
import React from 'react';
import 'moment/locale/sk';
import 'moment/locale/en-gb';
import 'moment/locale/uk';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { browserHistory, Redirect, Route, Router } from 'react-router';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import styled, { injectGlobal, ThemeProvider } from 'styled-components';
import 'url-search-params-polyfill';
import App from './containers/App';
import GeneralErrorBoundary from './components/GeneralErrorBoundary';
import ExternalConnectionForm from './containers/ExternalConnectionForm';
import LocaleProvider from './containers/LocaleProvider';
import { FORM_NAME as PASSENGERS_FORM_NAME } from './containers/Passengers/form';
import Payment from './containers/Payment';
import PaymentNok from './containers/Payment/Nok';
import PaymentOk from './containers/Payment/Ok';
import PaymentTout from './containers/Payment/Tout';
import { clearState, loadState, saveState } from './localStorage';
import reducer from './reducer';
import Api from './services/api';
import { theme } from './theme';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://52c1056c31a9460c81642ef7cb5fbe62@sentry.io/1330444',
    environment: process.env.NODE_ENV,
  });
}

// eslint-disable-next-line
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,500&subset=latin-ext');
  html, body {
    height: 100%;
    margin: 0;
  }
  #root {
    height: 100%;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  background-color: #fff;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  min-height: 500px;
  * {
    box-sizing: border-box;
  }
`;

const params = Api.paramsToObject(window.location.search);
if (params.ticketId) {
  // ak vyberame spiatocnu, cestu, nechceme mat pozostatky predosleho stavu
  clearState();
}

if (Object.keys(params).length === 0) {
  // ak nemame ziadne get parametre, pravdepodobne sme prisli directly na /reservation
  // toto nie je validny stav
  clearState();
}

const store = createStore(
  reducer,
  loadState(),
  composeEnhancers(
    applyMiddleware(routerMiddleware(browserHistory), thunkMiddleware),
  ),
);

store.subscribe(
  throttle(() => {
    const {
      connection,
      connectionParams,
      tickets,
      form: { [PASSENGERS_FORM_NAME]: passengerFormName },
      stepper,
      enterStations,
      stationTo,
      otherContent,
    } = store.getState();
    saveState({
      connection,
      connectionParams,
      enterStations,
      stationTo,
      tickets,
      form: { [PASSENGERS_FORM_NAME]: passengerFormName },
      stepper,
      otherContent,
    });
  }, 1000),
);

const history = syncHistoryWithStore(browserHistory, store);

const APP_BASE_PATH = '/reservation';

const $root = document.getElementById('root');
const $searchForm = document.getElementById('search-form');

if ($root) {
  ReactDOM.render(
    <GeneralErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <LocaleProvider>
            <Wrapper>
              <Router history={history}>
                <Route path={`${APP_BASE_PATH}`} component={App} />
                <Route
                  path={`${APP_BASE_PATH}/platba/:paygate`}
                  component={Payment}
                />
                <Route
                  path={`${APP_BASE_PATH}/platba-neuspesna`}
                  component={PaymentNok}
                />
                <Route
                  path={`${APP_BASE_PATH}/platba-vyprsala`}
                  component={PaymentTout}
                />
                <Route
                  path={`${APP_BASE_PATH}/platba-uspesna`}
                  component={PaymentOk}
                />
                <Redirect from="*" to={`${APP_BASE_PATH}`} />
              </Router>
            </Wrapper>
          </LocaleProvider>
        </ThemeProvider>
      </Provider>
    </GeneralErrorBoundary>,
    $root,
  );
} else if ($searchForm) {
  ReactDOM.render(
    <GeneralErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <LocaleProvider lang={$searchForm.dataset.lang}>
            <ExternalConnectionForm lang={$searchForm.dataset.lang} />
          </LocaleProvider>
        </ThemeProvider>
      </Provider>
    </GeneralErrorBoundary>,
    $searchForm,
  );
}



// WEBPACK FOOTER //
// ./src/index.js